import {
    DetailPage,
    DetailPagePanelConstraint,
    DetailPagePanelIndicator,
    DetailPagePropertyIndicator
} from "../../common/DetailPage";
import {RouteContext} from "../../../RouteContext";
import {ListPage} from "../../common/ListPage";
import {PlacePathJointValueObject} from "../../../../model/vo/content/place/PlacePathJointValueObject";
import {PlacePathJointIO} from "../../../../io/content/place/PlacePathJointIO";
import {PlacePathJointEventValueObject} from "../../../../model/vo/content/place/PlacePathJointEventValueObject";
import {PlacePathJointEventIO} from "../../../../io/content/place/PlacePathJointEventIO";

const propertyDetail: DetailPagePropertyIndicator<PlacePathJointEventValueObject> = {

}

type Panel = DetailPagePanelConstraint | 'PlacePathJoint'

const panelDescription: Record<Panel, string> = {
    Main: '기본',
    PlacePathJoint: '플레이스 경로 Joint'
}

const panelDetail: DetailPagePanelIndicator<PlacePathJointEventValueObject, Panel> = {
    PlacePathJoint: (props: RouteContext, item: PlacePathJointEventValueObject): JSX.Element => <>
        <ListPage
            {...props}
            description={PlacePathJointValueObject.description}
            list={PlacePathJointIO.list}
            count={PlacePathJointIO.count}
            detailHref={item => `/admin/places/paths/joints/${item.id}`}
            initialSearchConditions={[
                {
                    name: 'id',
                    value: String(item.placePathJointId),
                    condition: 'Equal'
                },
            ]}/>
    </>


}

export default function Detail(props: RouteContext) {
    return <>
        <DetailPage
            {...props}
            propertyDescription={PlacePathJointEventValueObject.description}
            propertyDetail={propertyDetail}
            panelDescription={panelDescription}
            panelDetail={panelDetail}
            get={PlacePathJointEventIO.get} />
    </>
}